localStorage.setItem('compares', '[]');
class ProductCompare extends HTMLElement {
  constructor() {
    super();
    this.maxCompareNum = 3;
    this.handleClick = this.handleClick.bind(this);
    this.updateStatus = this.updateStatus.bind(this);
  }

  get compareText() {
    return this.dataset.compareText || 'Compare';
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.render();
    this.updateStatus();
    this.querySelector('.card-compare')?.addEventListener('click', this.handleClick);
    document.addEventListener('compare-action-update', this.updateStatus);
    document.addEventListener('compare-update', this.updateStatus);
  }

  disconnectedCallback() {
    document.removeEventListener('compare-action-update', this.updateStatus);
    document.removeEventListener('compare-update', this.updateStatus);
  }

  /** 当前产品信息 */
  get productInfo() {
    return {
      id: this.dataset.id,
      title: this.dataset.title || '',
      image: this.dataset.image || '',
    };
  }

  /** 获取对比产品列表 */
  getCompareList() {
    return JSON.parse(localStorage.getItem('compares') || '[]');
  }

  /** 保存对比产品列表 */
  setCompareList(list) {
    localStorage.setItem('compares', JSON.stringify(list));
  }

  /** 更新按钮状态与文字 (勾选状态) */
  updateStatus() {
    const cardCompare = this.querySelector('.card-compare');
    if (!cardCompare) return;

    const list = this.getCompareList();
    const exists = list.some(item => item.id == this.productInfo.id);

    // 按钮样式 toggle
    cardCompare.classList.toggle('active', exists);

    // 这里根据你的SVG图标自行调整，保持原样
    const checkIcon = `
      <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.23229 11.0004C5.03409 11.0004 4.83477 10.9238 4.67263 10.7676L0.299031 6.5528C-0.0606386 6.20604 -0.101622 5.5979 0.207434 5.19464C0.516715 4.79139 1.05913 4.74544 1.4188 5.09195L5.7924 9.30678C6.15207 9.65354 6.19305 10.2617 5.88399 10.6649C5.71424 10.8867 5.47393 11.0004 5.23229 11.0004Z" fill="white"/>
      <path d="M5.5577 11C5.36711 11 5.17541 10.9292 5.01618 10.7841C4.64822 10.4483 4.59245 9.84171 4.89188 9.42916L11.4748 0.355445C11.7742 -0.0573506 12.3153 -0.119621 12.6832 0.216089C13.0512 0.5518 13.107 1.15844 12.8075 1.57098L6.22463 10.6447C6.05487 10.8785 5.80718 11 5.5577 11Z" fill="white"/>
      </svg>
    `;

    // 如果选中显示勾选图标，没选中显示空span或者加号(视你原CSS而定)
    cardCompare.innerHTML = `<span>${exists ? checkIcon : ''}</span> ${this.compareText}`;
  }

  /** 点击逻辑 */
  handleClick(event) {
    event.preventDefault(); // 防止跳转
    event.stopPropagation();

    let list = this.getCompareList();
    const index = list.findIndex(item => item.id == this.productInfo.id);

    if (index !== -1) {
      // 这里的confirm不需要，直接取消即可，体验更好
      list.splice(index, 1);
    } else if (list.length < this.maxCompareNum) {
      list.push(this.productInfo);
    } else {
      alert(`You can only compare up to ${this.maxCompareNum} products.`);
      return;
    }

    this.setCompareList(list);
    this.updateStatus();

    // 通知 Footer 更新
    document.dispatchEvent(new CustomEvent('compare-action-update'));
  }

  render() {
    if (!this.querySelector('.card-compare')) {
      this.innerHTML = `
        <button class="card-compare" type="button" aria-label="Add to compare">
          <span></span> ${this.compareText}
        </button>
      `;
    }
  }
}
customElements.define('product-compare', ProductCompare);

class ProductCompareFooter extends HTMLElement {
  constructor() {
    super();
    this.handleCompare = this.handleCompare.bind(this);
    this.clearAll = this.clearAll.bind(this);
  }

  connectedCallback() {
    this.render();
    this.setTransition();
    document.addEventListener('compare-action-update', () => this.render());
  }

  disconnectedCallback() {
    document.removeEventListener('compare-action-update', () => this.render());
  }
  get clearAllText() {
    return 'Clear All'
  }
  get compareText() {
    return 'Compare'
  }
  get collectionHandle() {
    return this.dataset.handle;
  }
  setTransition() {
    const footer = document.querySelector('footer');
    if (!footer) return;
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        this.classList.remove('show');
      } else {
        const list = this.getCompareList();
        if (list.length > 0) this.classList.add('show');
      }
    }, { root: null, threshold: 0 });

    observer.observe(footer);
  }

  getCompareList() {
    return JSON.parse(localStorage.getItem('compares') || '[]');
  }

  setCompareList(list) {
    localStorage.setItem('compares', JSON.stringify(list));
  }

  handleCompare() {
    const list = this.getCompareList();
    if (!list.length) return;
    const rawIds = list.map(item => item.id).join(',');
    const rawHandle = this.collectionHandle || '';
    window.location.href = `/pages/compare?id=${encodeURIComponent(rawIds)}&handle=${encodeURIComponent(rawHandle)}`;
  }

  /** 清空所有 */
  clearAll() {
    this.setCompareList([]);
    this.render();
    document.dispatchEvent(new CustomEvent('compare-action-update'));
    document.dispatchEvent(new CustomEvent('compare-update')); // 通知所有卡片按钮更新状态
  }

  /** 删除单个产品 (对应截图的小X) */
  removeItem(id) {
    let list = this.getCompareList();
    list = list.filter(item => item.id != id); // 注意类型转换，用!=比较安全
    this.setCompareList(list);
    this.render();
    document.dispatchEvent(new CustomEvent('compare-action-update'));
    document.dispatchEvent(new CustomEvent('compare-update')); // 通知所有卡片按钮更新状态
  }

  render() {
    const list = this.getCompareList();
    // 如果没有产品，隐藏并清空
    if (!list.length) {
      this.innerHTML = '';
      this.classList.remove('show');
      return;
    }

    this.classList.add('show');

    const itemsHtml = list.map(item => `
      <div class="compare-item-card">
        <div class="compare-item-info">
          <img src="${item.image}" alt="${item.title}" />
          <div class="compare-item-title text-ellipsis line-2 fz-14 lh-16 fz-m-12 lh-m-14">${item.title}</div>
        </div>
        <button class="compare-item-remove" data-id="${item.id}" aria-label="Remove product">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_102_8911" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <rect width="24" height="24" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_102_8911)">
          <path d="M6.40141 18.6538L5.34766 17.6L10.9477 12L5.34766 6.4L6.40141 5.34625L12.0014 10.9463L17.6014 5.34625L18.6552 6.4L13.0552 12L18.6552 17.6L17.6014 18.6538L12.0014 13.0538L6.40141 18.6538Z" fill="#1C1B1F"/>
          </g>
          </svg>
        </button>
      </div>
    `).join('');

    // 2. 生成整体结构
    this.innerHTML = `
      <div class="compare-footer-container">
        <div class="container">
          <div class="compare-footer-wrapper">

            <div class="compare-list">
              ${itemsHtml}
            </div>

            <div class="compare-actions">
              <button class="compare-go-btn fz-16 fw-500 fz-m-14">${this.compareText}</button>
              <span class="compare-clear-btn fz-16 fz-m-12">${this.clearAllText}</span>
            </div>

          </div>
        </div>
      </div>
    `;

    // 3. 绑定事件
    this.querySelector('.compare-go-btn').addEventListener('click', this.handleCompare);
    this.querySelector('.compare-clear-btn').addEventListener('click', this.clearAll);

    // 绑定单个删除事件
    this.querySelectorAll('.compare-item-remove').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const id = e.currentTarget.dataset.id;
        this.removeItem(id);
      });
    });
  }
}
customElements.define('product-compare-footer', ProductCompareFooter);

if (!customElements.get('main-collection')) {
  customElements.define('main-collection', class extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('.view-btn');
      this.storageKey = 'view-mode';
    }

    connectedCallback() {
      // 1. 获取 URL 参数
      const urlParams = new URLSearchParams(window.location.search);
      const urlMode = urlParams.get('view');

      // 2. 获取缓存或默认值
      const savedMode = localStorage.getItem(this.storageKey) || 'grid';

      // 3. 确定最终模式
      const initialMode = urlMode || savedMode;

      // 4. 执行模式设置
      // 注意：这里我们始终调用 setMode，但根据 URL 是否存在参数决定是否需要“补全” URL
      const shouldUpdateUrl = !urlMode; // 如果 URL 里本来没带参数，我们就给它补上
      this.setMode(initialMode, shouldUpdateUrl);
      this.querySelector(".collection").style.display = 'block';
      // 5. 绑定点击事件
      this.buttons.forEach(btn => {
        btn.addEventListener('click', () => this.setMode(btn.dataset.view, true));
      });
    }

    setMode(mode, updateUrl = true) {
      // 切换 Class (在 main-collection 标签上)
      this.classList.toggle('list-mode', mode === 'list');

      // 更新按钮 UI
      this.buttons.forEach(btn => {
        btn.classList.toggle('active', btn.dataset.view === mode);
      });

      // 存入 LocalStorage
      localStorage.setItem(this.storageKey, mode);

      // 更新 URL 参数 (不刷新页面)
      if (updateUrl) {
        const url = new URL(window.location.href);
        // 只有当当前的 view 参数不等于要设置的 mode 时才更新，避免重复操作
        if (url.searchParams.get('view') !== mode) {
          url.searchParams.set('view', mode);
          window.history.replaceState({ path: url.href }, '', url.href);
        }
      }
    }
  });
}

class QuickVariantAdd extends HTMLElement {
  constructor() {
    super();
    // 绑定 Selectors
    this.trigger = this.querySelector('.qva-trigger');
    this.popup = this.querySelector('.qva-popup');
    this.rows = this.querySelectorAll('.qva-row');
    this.clearBtn = this.querySelector('.qva-clear');
    this.addBtn = this.querySelector('.qva-add-btn');

    // 绑定 Methods
    this.togglePopup = this.togglePopup.bind(this);
    this.handleQuantity = this.handleQuantity.bind(this);
    this.clearAll = this.clearAll.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.validateInput = this.validateInput.bind(this);

    // Resize 防抖绑定
    this.handleResize = this.debounce(this.adjustOffset.bind(this), 100);
  }

  connectedCallback() {
    this.trigger.addEventListener('click', this.togglePopup);
    this.clearBtn.addEventListener('click', this.clearAll);
    this.addBtn.addEventListener('click', this.addToCart);
    document.addEventListener('click', this.handleClickOutside);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.rows.forEach(row => {
      // 按钮点击
      row.addEventListener('click', (e) => this.handleQuantity(e, row));

      // 输入框监听
      const input = row.querySelector('.qty-input');
      input.addEventListener('input', (e) => this.validateInput(e, row));
      input.addEventListener('change', (e) => this.validateInput(e, row));
    });
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleClickOutside);
    window.removeEventListener('resize', this.handleResize);
  }

  // 防抖函数
  debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  // 1. 弹窗开关 & 50vh定位
  togglePopup() {
    const isActive = this.popup.classList.contains('active');
    if (isActive) {
      this.popup.classList.remove('active');
      return;
    }

    // 垂直定位
    const rect = this.trigger.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    this.popup.classList.remove('position-top', 'position-bottom');

    if (rect.top > viewportHeight / 2) {
      this.popup.classList.add('position-top');
    } else {
      this.popup.classList.add('position-bottom');
    }

    // 水平定位 (Resize逻辑)
    this.adjustOffset();

    this.popup.classList.add('active');
  }

  // 2. Resize 偏移计算逻辑
  adjustOffset() {
    const width = window.innerWidth;
    // 如果屏幕在 1000 - 1400 之间，向左偏移 (宽度 - 1400) px
    if (width >= 1000 && width < 1400) {
      const offset = width - 1400;
      this.popup.style.transform = `translateX(${offset}px)`;
    } else {
      this.popup.style.transform = '';
    }
  }

  // 3. 点击外部关闭
  handleClickOutside(event) {
    if (!this.contains(event.target)) {
      this.popup.classList.remove('active');
    }
  }

  // 4. 按钮加减数量
  handleQuantity(e, row) {
    // 使用 closest 确保点击到 svg 或 path 时也能找到对应的按钮
    const plusBtn = e.target.closest('.plus');
    const minusBtn = e.target.closest('.minus');

    const input = row.querySelector('.qty-input');
    if (input.disabled) return;

    let value = parseInt(input.value) || 0;

    if (plusBtn) {
      value++;
    } else if (minusBtn) {
      if (value > 0) value--;
    } else {
      // 如果既没点到 plus 也没点到 minus，直接返回
      return;
    }

    input.value = value;
    this.updateRowState(row, value);
  }

  // 5. 输入框验证 (非数字归零，01变1)
  validateInput(e, row) {
    const input = e.target;
    let value = input.value;

    if (value === '') {
      if (e.type === 'change') {
        input.value = 0;
        this.updateRowState(row, 0);
      } else {
        this.updateRowState(row, 0);
      }
      return;
    }

    let intValue = parseInt(value);
    if (isNaN(intValue)) intValue = 0;

    // 如果格式不对(如01)或者失焦，强制格式化
    if (intValue.toString() !== value || e.type === 'change') {
      input.value = intValue;
    }

    this.updateRowState(row, intValue);
  }

  updateRowState(row, value) {
    if (value > 0) row.classList.add('has-qty');
    else row.classList.remove('has-qty');
  }

  // 6. 清空
  clearAll() {
    this.rows.forEach(row => {
      const input = row.querySelector('.qty-input');
      input.value = 0;
      row.classList.remove('has-qty');
    });
  }
  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper =
      this.errorMessageWrapper || this.querySelector('.variants-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.variants-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
  addToCart() {
    if (this.addBtn.disabled) return
    this.handleErrorMessage();
    // 1. 收集选中的产品 (保留原本逻辑)
    if (!this.cartDrawer) this.cartDrawer = document.querySelector('cart-drawer');
    const items = [];
    this.rows.forEach(row => {
      const input = row.querySelector('.qty-input');
      // 增加安全性判断：如果 input 被禁用或不存在则跳过
      if (!input || input.disabled) return;

      const qty = parseInt(input.value);
      const variantId = row.dataset.variantId;
      if (qty > 0 && variantId) {
        items.push({ id: parseInt(variantId), quantity: qty });
      }
    });

    if (items.length === 0) return;

    // 2. 设置 Loading 状态
    const originalText = this.addBtn.innerText;
    this.addBtn.innerText = 'Adding...';
    this.addBtn.disabled = true;

    // 3. 准备需要更新的 Section (关键步骤：为了让抽屉能打开，必须请求这些 HTML)
    let sectionsToRender = [];
    if (this.cartDrawer) {
      sectionsToRender = this.cartDrawer.getSectionsToRender().map((section) => section.id);
    }
    // 5. 发送请求
    fetch("/cart/add.js", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: sectionsToRender,
        sections_url: window.location.pathname
      })
    })
      .then(response => response.json())
      .then(data => {
        this.clearAll();
        if (data.status) {
          this.handleErrorMessage(data.description);
          if (this.cartDrawer) this.cartDrawer.reload();
        } else {
          if (this.cartDrawer) this.cartDrawer.renderContents(data);
          this.popup.classList.remove('active');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (this.cartDrawer && this.cartDrawer.classList.contains('is-empty')) this.cartDrawer.classList.remove('is-empty');
        this.addBtn.innerText = originalText;
        this.addBtn.disabled = false;
      });
  }
}

customElements.define('quick-variant-add', QuickVariantAdd);
